module.exports = __webpack_public_path__ + "img/hr-lab-shadow.eb5e407a.png";